import type { TFunction } from 'i18next';
import { PerformanceTab } from './initiative-performance.type';

/**
 * Returns the performance tabs configuration.
 *
 * @param {TFunction} t - Translation function from `useTranslation()` so the
 *   tab labels respect org-level text_config overrides
 * @returns {Array<{ id: PerformanceTab; label: string; icon: string }>} The performance tabs configuration.
 */
const getTabs = (t: TFunction): { id: PerformanceTab; label: string; icon: string }[] => [
  {
    id: PerformanceTab.Throughput,
    label: t('strategy.initiative_performance.throughput'),
    icon: 'calendar_month',
  },
  { id: PerformanceTab.Focus, label: t('strategy.initiative_performance.focus'), icon: 'center_focus_strong' },
  {
    id: PerformanceTab.FlowByPhase,
    label: t('strategy.initiative_performance.flow_by_phase'),
    icon: 'swap_calls',
  },
  { id: PerformanceTab.Targets, label: t('strategy.initiative_performance.targets'), icon: 'ads_click' },
  { id: PerformanceTab.Cost, label: t('strategy.initiative_performance.cost'), icon: 'payments' },
  {
    id: PerformanceTab.RelatedTasks,
    label: t('common.related_tasks', { work_units: t('common.work_units') }),
    icon: 'task_alt',
  },
];

export { getTabs };
